import React, { useEffect, useRef, useState } from "react";
import { formatDate } from "../../../../../../utils/commonFunctions";
import { Card, message } from "antd";
import swal from "sweetalert";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import ReactLoading from "react-loading";
import {
  hasNumeric,
  hasSpecialCharacter,
  isNameValid,
  isPinValid,
  isValidAddress,
  isGreaterThan100Char,
  calculateAgeFormDOB,
} from "./commonfunctions";
import useAxios from "../../../../../../hooks/useAxios";

function Mediclaim({
  form,
  filledForm,
  getAllJoiningFilledForms,
  aadharDetails,
  metaData,
  setMediclaimPreviewData,
  setActivePanel,
  application,
  setIsFieldTouch,
}) {
  let row = 0;
  let _aadhar = aadharDetails || {};
  const IS_DISABLE =
    filledForm?.formStatusByHR === false
      ? !application?.candidateSignatureStatus
        ? true
        : false
      : false;
  const { house, street, state, loc, dist } =
    _aadhar?.aadharVerificationDetails?.data?.address || {};
  const ADDRESS =
    _aadhar?.aadharVerificationDetails?.data?.full_address ||
    [house, street, state, loc, dist].filter(Boolean).join(", ") ||
    "";

  const DOB = application?.responses?.find(
    (item) => item?.label === "Date of Birth"
  )?.value;

  const AADHAR_GENDER = _aadhar?.aadharVerificationDetails?.data?.gender || "";

  const FORM_GENDER =
    application?.responses?.find((item) => item?.label === "Gender")?.value ||
    "";

  const GENDER = AADHAR_GENDER
    ? AADHAR_GENDER === "M"
      ? "male"
      : AADHAR_GENDER === "F"
      ? "female"
      : ""
    : FORM_GENDER
    ? FORM_GENDER?.toLowerCase()
    : "";

  const api = useAxios();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name:
      filledForm?.documentDetails?.name ||
      _aadhar?.aadharVerificationDetails?.data?.full_name ||
      (metaData?.first_name || metaData?.last_name
        ? `${metaData?.first_name} ${metaData?.last_name}`
        : undefined) ||
      "",
    address:
      filledForm?.documentDetails?.address ||
      (ADDRESS ? ADDRESS : undefined) ||
      metaData?.permanent_address ||
      "",
    pin:
      filledForm?.documentDetails?.pin ||
      _aadhar?.aadharVerificationDetails?.data?.zip ||
      metaData?.pin_code ||
      "",
    // state: filledForm?.documentDetails?.state || metaData?.Select_State || "",
    relationship: filledForm?.documentDetails?.relationship || "Self",
    // place: filledForm?.documentDetails?.place || "",
    dob:
      filledForm?.documentDetails?.dob ||
      _aadhar?.aadharVerificationDetails?.data?.dob ||
      DOB ||
      "",
    age:
      filledForm?.documentDetails?.age ||
      calculateAgeFormDOB(
        filledForm?.documentDetails?.dob ||
          _aadhar?.aadharVerificationDetails?.data?.dob ||
          DOB
      ).toString(),
    sex:
      filledForm?.documentDetails?.sex ||
      GENDER ||
      metaData?.gender?.toLowerCase() ||
      "",
    mediclaim_history_yes_no:
      filledForm?.documentDetails?.mediclaim_history_yes_no || "",
    disease_yes_no: filledForm?.documentDetails?.disease_yes_no || "",
    dental_yes_no: filledForm?.documentDetails?.dental_yes_no || "",
    insurer_yes_no: filledForm?.documentDetails?.insurer_yes_no || "",
    table_illness_accident_yes_no:
      filledForm?.documentDetails?.table_illness_accident_yes_no || "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [errorMedicalHistory, setErrorMedicalHistory] = useState({});
  const [mediclaimHistory, setMediclaimHistory] = useState({
    not_in_good_health:
      filledForm?.documentDetails?.mediclaim_history?.not_in_good_health || "",
  });

  const [errorDentalHistory, setErrorDentalHistory] = useState({});
  const [dentalHistory, setDentalHistory] = useState({
    specify_name:
      filledForm?.documentDetails?.dental_history?.specify_name || "",
    last_treatment:
      filledForm?.documentDetails?.dental_history?.last_treatment || "",
  });

  const [errorInsaurance, setErrorInsaurance] = useState({});
  const [insaurance, setInsaurance] = useState({
    insurerAndPolicyNumber:
      filledForm?.documentDetails?.insurer_history?.insurerAndPolicyNumber ||
      "",
    period_form:
      filledForm?.documentDetails?.insurer_history?.period_form || "",
    period_to: filledForm?.documentDetails?.insurer_history?.period_to || "",
    claim_amount:
      filledForm?.documentDetails?.insurer_history?.claim_amount || "",
  });

  const [errorDisease, setErrorDisease] = useState({});

  const [disease, setDisease] = useState({
    nervous_mental:
      filledForm?.documentDetails?.disease_history?.nervous_mental || "",
    spinal_disorder:
      filledForm?.documentDetails?.disease_history?.spinal_disorder || "",
    blood_pressure:
      filledForm?.documentDetails?.disease_history?.blood_pressure || "",
    rheumatic_fever:
      filledForm?.documentDetails?.disease_history?.rheumatic_fever || "",
    piles_hernia:
      filledForm?.documentDetails?.disease_history?.piles_hernia || "",
    bones_joints:
      filledForm?.documentDetails?.disease_history?.bones_joints || "",
    respiratory_allergic:
      filledForm?.documentDetails?.disease_history?.respiratory_allergic || "",
    stomach_bladder_kidney:
      filledForm?.documentDetails?.disease_history?.stomach_bladder_kidney ||
      "",
    cancer_wound:
      filledForm?.documentDetails?.disease_history?.cancer_wound || "",
    surgical_hospital_treatment:
      filledForm?.documentDetails?.disease_history
        ?.surgical_hospital_treatment || "",
    treatment_in_the_future:
      filledForm?.documentDetails?.disease_history?.treatment_in_the_future ||
      "",
    dimness_of_vision:
      filledForm?.documentDetails?.disease_history?.dimness_of_vision || "",
    disease_of_ears:
      filledForm?.documentDetails?.disease_history?.disease_of_ears || "",
    urinary_disease:
      filledForm?.documentDetails?.disease_history?.urinary_disease || "",
    illness_disease_accident:
      filledForm?.documentDetails?.disease_history?.illness_disease_accident ||
      "",
  });

  const [nomineeError, setNomineeError] = useState({});
  const [nominees, setNominees] = useState(
    !filledForm?.documentDetails
      ? [
          {
            nature_of_all: "",
            date_of_treatment: "",
            name_address_tel_practitioner_disease: "",
            fully_cured: "",
          },
        ]
      : [...filledForm?.documentDetails?.nominees]
  );

  const handleChange = (e) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;

    if (name === "dob") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        age: calculateAgeFormDOB(value).toString(),
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateNominee = () => {
    for (let i = 0; i < nominees.length; i++) {
      let nominee = nominees[i];
      if (nominee) {
        let keys = Object.keys(nominee);
        for (let j = 0; j < keys.length; j++) {
          let key = keys[j];
          if (nominee[key] === "") {
            return true;
          }
        }
      }
    }
    return false;
  };

  const addMore = (e) => {
    setNominees((prev) => {
      return [
        ...prev,
        {
          nature_of_all: "",
          date_of_treatment: "",
          name_address_tel_practitioner_disease: "",
          fully_cured: "",
        },
      ];
    });
  };

  const deleteNominee = (_index) => {
    setNominees((prev) => {
      let arr = [...prev];
      // arr.splice(_index,1)
      arr[_index] = null;
      return [...arr];
    });

    for (let key in nomineeError) {
      if (key.endsWith(_index)) {
        delete nomineeError[key];
      }
    }
  };

  const handleChangeNominee = (e, _index) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;
    setNominees((prev) => {
      let arr = [...prev];

      arr.forEach((item, index) => {
        if (index === _index) {
          item[name] = value;
        }
      });

      if (name === "nature_of_all") {
        let valid = isGreaterThan100Char(value);
        if (valid) {
          setNomineeError({
            ...nomineeError,
            [`nature_of_all_${_index}`]: {
              message: valid,
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`nature_of_all_${_index}`]: "",
          });
        }
      }

      if (name === "name_address_tel_practitioner_disease") {
        let valid = isGreaterThan100Char(value);
        if (valid) {
          setNomineeError({
            ...nomineeError,
            [`name_address_tel_practitioner_disease_${_index}`]: {
              message: valid,
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`name_address_tel_practitioner_disease_${_index}`]: "",
          });
        }
      }

      if (name === "date_of_treatment") {
        if (value && new Date() < new Date(value)) {
          setNomineeError({
            ...nomineeError,
            [`date_of_treatment_${_index}`]: {
              message: "Future date is not allowed.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`date_of_treatment_${_index}`]: "",
          });
        }
      }

      if (name === "fully_cured") {
        if (value && (hasSpecialCharacter(value) || hasNumeric(value))) {
          setNomineeError({
            ...nomineeError,
            [`fully_cured_${_index}`]: {
              message: "Special charcters not allowed.",
              index: _index,
            },
          });
        } else {
          let valid = isGreaterThan100Char(value);
          if (valid) {
            setNomineeError({
              ...nomineeError,
              [`fully_cured_${_index}`]: {
                message: valid,
                index: _index,
              },
            });
          } else {
            setNomineeError({
              ...nomineeError,
              [`fully_cured_${_index}`]: "",
            });
          }
        }
      }

      return [...arr];
    });
  };

  const isFormDataEmpty = () => {
    for (let key in formData) {
      if (
        key !== "mediclaim_history" &&
        key !== "mediclaim_history_yes_no" &&
        key !== "disease_history" &&
        key !== "disease_yes_no" &&
        key !== "dental_history" &&
        key !== "dental_yes_no" &&
        key !== "insurer_yes_no" &&
        key !== "insurer_history" &&
        key !== "table_illness_accident_yes_no" &&
        formData[key]?.trim() === ""
      ) {
        return true;
      }
    }
    return false;
  };

  const validateInsurance = () => {
    for (let key in insaurance) {
      if (insaurance[key]?.trim() === "") {
        return true;
      }
    }
    return false;
  };

  const validateDental = () => {
    for (let key in dentalHistory) {
      if (dentalHistory[key]?.trim() === "") {
        return true;
      }
    }
    return false;
  };

  const validateInput = (e) => {
    if (isFormDataEmpty()) {
      return true;
    }

    return false;
  };

  const checkMedicalHistoryError = () => {
    for (let key in errorMedicalHistory) {
      if (errorMedicalHistory[key] !== "") {
        return true;
      }
    }
    return false;
  };

  const checkDiseaseHistoryError = () => {
    for (let key in errorDisease) {
      if (errorDisease[key] !== "") {
        return true;
      }
    }
    return false;
  };

  const checkDentalHistoryError = () => {
    for (let key in errorDentalHistory) {
      if (errorDentalHistory[key] !== "") {
        return true;
      }
    }
    return false;
  };

  const checkInsurerHistoryError = () => {
    for (let key in errorInsaurance) {
      if (errorInsaurance[key] !== "") {
        return true;
      }
    }
    return false;
  };

  const checkNomineeError = () => {
    for (let key in nomineeError) {
      if (nomineeError[key] !== "") {
        return true;
      }
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let flag = false;
    for (let key in error) {
      if (error[key] !== "") {
        flag = true;
        break;
      }
    }

    if (
      flag ||
      (formData?.mediclaim_history_yes_no === "yes" &&
        checkMedicalHistoryError()) ||
      (formData?.disease_yes_no === "yes" && checkDiseaseHistoryError()) ||
      (formData?.dental_yes_no === "yes" && checkDentalHistoryError()) ||
      (formData?.insurer_yes_no === "yes" && checkInsurerHistoryError()) ||
      (formData?.table_illness_accident_yes_no === "yes" && checkNomineeError())
    ) {
      swal({
        title: "Error",
        // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
        icon: "error",
        content: {
          element: "div",
          attributes: {
            innerHTML: `
                  <p style="text-align:center">Before submit please resolve all the errors.</p>       
                `,
          },
        },
        buttons: {
          cancel: false,
          confirm: true,
        },
      }).then((flag) => {});
      return;
    }

    const data = {
      companyDocumentId: form?._id,
      candidateId: id,
      documentDetails: {
        ...formData,
        ...(formData?.mediclaim_history_yes_no === "yes"
          ? { mediclaim_history: { are_you_in_good_health: "yes" } }
          : {
              mediclaim_history: {
                not_in_good_health: mediclaimHistory.not_in_good_health,
              },
            }),
        ...(formData?.disease_yes_no === "yes"
          ? { disease_history: disease }
          : {}),
        ...(formData?.dental_yes_no === "yes"
          ? { dental_history: dentalHistory }
          : {}),
        ...(formData?.insurer_yes_no === "yes"
          ? { insurer_history: insaurance }
          : {}),
        ...(formData?.table_illness_accident_yes_no === "yes"
          ? { nominees: [...nominees.filter((nom) => nom !== null)] }
          : {
              nominees: [
                {
                  name_of_establishment: "",
                  ppo_number: "",
                  ncp_days: "",
                  date_of_joining: "",
                  date_of_exit: "",
                  universal_account_number: "",
                  pf_account_number: "",
                  scheme_certificate: "",
                },
              ],
            }),
      },
      formStatus: true,
    };

    try {
      setLoading(true);
      await api.post(`/companyDocuments/DocumentMaping`, data, {
        tokenType: "candidate",
      });
      await getAllJoiningFilledForms();
      message.success("Your form has been submitted successfully!");
      setActivePanel(null);
      setIsFieldTouch(false);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setMediclaimPreviewData({
      ...formData,
      ...(formData?.mediclaim_history_yes_no === "yes"
        ? { mediclaim_history: { are_you_in_good_health: "yes" } }
        : {
            mediclaim_history: {
              not_in_good_health: mediclaimHistory?.not_in_good_health,
            },
          }),
      ...(formData?.disease_yes_no === "yes"
        ? { disease_history: disease }
        : {}),
      ...(formData?.dental_yes_no === "yes"
        ? { dental_history: dentalHistory }
        : {}),
      ...(formData?.insurer_yes_no === "yes"
        ? { insurer_history: insaurance }
        : {}),
      ...(formData?.table_illness_accident_yes_no === "yes"
        ? { nominees }
        : {}),
    });

    let e = {};
    let eMH = {};
    let eDH = {};
    let eDenH = {};
    let eIn = {};

    // if (formData?.name.trim()) {
    //   e.name = isNameValid(formData.name);
    // }

    // if (formData?.address.trim()) {
    //   e.address = isValidAddress(formData.address);
    // }

    // if (formData?.pin.trim()) {
    //   e.pin = isPinValid(formData?.pin);
    // }

    // if (formData.state && formData.state?.trim().length < 3) {
    //   e.state = "State must be greater than 3 char";
    // } else {
    //   if (
    //     hasNumeric(formData.state?.trim()) ||
    //     hasSpecialCharacter(formData.state?.trim())
    //   ) {
    //     e.state = "No numeric or special character allowed.";
    //   } else {
    //     e.state = "";
    //   }
    // }

    if (formData.relationship && formData.relationship?.trim().length < 3) {
      e.relationship = "Relationship must be greater than 3 char";
    } else {
      if (
        hasNumeric(formData.relationship?.trim()) ||
        hasSpecialCharacter(formData.relationship?.trim())
      ) {
        e.relationship = "No numeric or special character allowed.";
      } else {
        e.relationship = "";
      }
    }

    // if (formData?.place && formData?.place?.trim().length < 3) {
    //   e.place = "Place must be more than 3 char.";
    // } else {
    //   if (
    //     hasNumeric(formData.place?.trim()) ||
    //     hasSpecialCharacter(formData.place?.trim())
    //   ) {
    //     e.place = "No numeric or special character allowed.";
    //   } else {
    //     e.place = "";
    //   }
    // }

    // if (new Date(formData.dob) > new Date()) {
    //   e.dob = "Future date is not allowed.";
    // } else {
    //   e.dob = "";
    // }

    // if (formData.age && formData.age < 18) {
    //   e.age = "Age must be greater than or equal to 18";
    // } else {
    //   e.age = "";
    // }

    if (mediclaimHistory?.not_in_good_health) {
      eMH.not_in_good_health = isGreaterThan100Char(
        mediclaimHistory?.not_in_good_health
      );
    }

    if (disease?.nervous_mental) {
      eDH.nervous_mental = isGreaterThan100Char(disease?.nervous_mental);
    }

    if (disease?.spinal_disorder) {
      eDH.spinal_disorder = isGreaterThan100Char(disease?.spinal_disorder);
    }

    if (disease?.blood_pressure) {
      eDH.blood_pressure = isGreaterThan100Char(disease?.blood_pressure);
    }

    if (disease?.rheumatic_fever) {
      eDH.rheumatic_fever = isGreaterThan100Char(disease?.rheumatic_fever);
    }

    if (disease?.piles_hernia) {
      eDH.piles_hernia = isGreaterThan100Char(disease?.piles_hernia);
    }

    if (disease?.piles_hernia) {
      eDH.piles_hernia = isGreaterThan100Char(disease?.piles_hernia);
    }

    if (disease?.respiratory_allergic) {
      eDH.respiratory_allergic = isGreaterThan100Char(
        disease?.respiratory_allergic
      );
    }

    if (disease?.stomach_bladder_kidney) {
      eDH.stomach_bladder_kidney = isGreaterThan100Char(
        disease?.stomach_bladder_kidney
      );
    }

    if (disease?.cancer_wound) {
      eDH.cancer_wound = isGreaterThan100Char(disease?.cancer_wound);
    }

    if (disease?.surgical_hospital_treatment) {
      eDH.surgical_hospital_treatment = isGreaterThan100Char(
        disease?.surgical_hospital_treatment
      );
    }

    if (disease?.treatment_in_the_future) {
      eDH.treatment_in_the_future = isGreaterThan100Char(
        disease?.treatment_in_the_future
      );
    }

    if (disease?.dimness_of_vision) {
      eDH.dimness_of_vision = isGreaterThan100Char(disease?.dimness_of_vision);
    }

    if (disease?.disease_of_ears) {
      eDH.disease_of_ears = isGreaterThan100Char(disease?.disease_of_ears);
    }

    if (disease?.urinary_disease) {
      eDH.urinary_disease = isGreaterThan100Char(disease?.urinary_disease);
    }

    if (disease?.illness_disease_accident) {
      eDH.illness_disease_accident = isGreaterThan100Char(
        disease?.illness_disease_accident
      );
    }

    if (disease?.bones_joints) {
      eDH.bones_joints = isGreaterThan100Char(disease?.bones_joints);
    }

    if (dentalHistory?.specify_name) {
      eDenH.specify_name = isGreaterThan100Char(dentalHistory?.specify_name);
    }

    if (dentalHistory?.last_treatment) {
      eDenH.last_treatment = isGreaterThan100Char(
        dentalHistory?.last_treatment
      );
    }

    if (
      insaurance?.period_form !== "" &&
      new Date() < new Date(insaurance?.period_form)
    ) {
      eIn.period_form = "Future Date is not allowed";
    } else {
      if (new Date(insaurance?.period_form) > new Date(insaurance?.period_to)) {
        eIn.period_form = "Period From date must be less than Period To";
      } else {
        eIn.period_form = "";
      }
    }

    if (
      insaurance?.period_to !== "" &&
      new Date() < new Date(insaurance?.period_to)
    ) {
      eIn.period_to = "Future Date is not allowed";
    } else {
      if (new Date(insaurance?.period_form) > new Date(insaurance?.period_to)) {
        eIn.period_to = "Period To date must be greater than Period From";
      } else {
        eIn.period_to = "";
      }
    }

    setErrorInsaurance(eIn);
    setErrorDisease(eDH);
    setErrorDentalHistory(eDenH);
    setErrorMedicalHistory(eMH);
    setError(e);
  }, [formData, mediclaimHistory, disease, dentalHistory, insaurance]);

  return (
    <Card>
      {loading ? (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      ) : (
        <div className="row">
          <div className="col-12">
            <p style={{ color: "red", fontSize: "14px" }}>
              <strong>Note:</strong> All fields marked with an asterisk (
              <span style={{ color: "red" }}>*</span>) are mandatory.
            </p>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Name of Insured Person
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  disabled={filledForm?.formStatusByHR || true}
                  name="name"
                  onChange={handleChange}
                  style={{
                    ...(error?.name ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.name.replaceAll(/\b[a-z]/g, (p) =>
                    p.toUpperCase()
                  )}
                />
                {error?.name && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.name}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Address
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  disabled={filledForm?.formStatusByHR || true}
                  name="address"
                  onChange={handleChange}
                  style={{
                    ...(error?.address ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.address}
                />
                {error?.address && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.address}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Pin
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="number"
                  placeholder=""
                  disabled={filledForm?.formStatusByHR || true}
                  name="pin"
                  onChange={handleChange}
                  min={0}
                  style={{
                    ...(error?.pin ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.pin}
                />
                {error?.pin && (
                  <p style={{ color: "red", fontSize: "10px" }}>{error?.pin}</p>
                )}
              </div>
              {/* <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  State / U. Territory
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="state"
                  disabled={filledForm?.formStatusByHR}
                  onChange={handleChange}
                  style={{
                    ...(error?.state ? { border: "1px solid red" } : {})
                  }}
                  value={formData?.state}
                />
                {error?.state && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.state}
                  </p>
                )}
              </div> */}
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Relationship With The Prosper
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="relationship"
                  disabled={filledForm?.formStatusByHR}
                  onChange={handleChange}
                  style={{
                    ...(error?.relationship ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.relationship}
                />
                {error?.relationship && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.relationship}
                  </p>
                )}
              </div>
              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Sex
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="medi_male"
                      disabled={filledForm?.formStatusByHR}
                      name="sex"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="male"
                      checked={formData?.sex === "male"}
                    />
                    <label htmlFor="medi_male" className="custom-control-label">
                      Male
                    </label>
                  </div>

                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="medi_female"
                      name="sex"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="female"
                      checked={formData?.sex === "female"}
                    />
                    <label
                      htmlFor="medi_female"
                      className="custom-control-label"
                    >
                      Female
                    </label>
                  </div>
                </div>
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Date of Birth
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="date"
                  disabled={filledForm?.formStatusByHR || true}
                  name="dob"
                  max={formatDate(new Date())}
                  onChange={handleChange}
                  style={{
                    ...(error?.dob ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.dob}
                />
                {error?.dob && (
                  <p style={{ color: "red", fontSize: "10px" }}>{error?.dob}</p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Age
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="number"
                  disabled={filledForm?.formStatusByHR || true}
                  name="age"
                  min={0}
                  onChange={handleChange}
                  style={{
                    ...(error?.age ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.age}
                />
                {error?.age && (
                  <p style={{ color: "red", fontSize: "10px" }}>{error?.age}</p>
                )}
              </div>
              {/* <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Place
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="place"
                  disabled={filledForm?.formStatusByHR}
                  onChange={handleChange}
                  style={{
                    ...(error?.place ? { border: "1px solid red" } : {})
                  }}
                  value={formData?.place}
                />
                {error?.place && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.place}
                  </p>
                )}
              </div> */}
            </div>
            <div className="row">
              <div className="form-group mb-3 col-md-12 form-builder-element">
                <label htmlFor="">
                  Are you at present or any other time in the past covered
                  insurance Type (PA, Cancer Insurance, Hospitalisation
                  Insurance or other Medical Insurance) If so, give particular
                  of:
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="medi_point_10_yes"
                      disabled={filledForm?.formStatusByHR}
                      type="checkbox"
                      name="insurer_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="yes"
                      checked={formData?.insurer_yes_no === "yes"}
                    />
                    <label
                      htmlFor="medi_point_10_yes"
                      className="custom-control-label"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="medi_point_10_no"
                      type="checkbox"
                      name="insurer_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="no"
                      checked={formData?.insurer_yes_no === "no"}
                    />
                    <label
                      htmlFor="medi_point_10_no"
                      className="custom-control-label"
                    >
                      No
                    </label>
                  </div>
                </div>
                {formData?.insurer_yes_no === "yes" && (
                  <div className="row">
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Insurer and Policy No.
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="number"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setInsaurance({
                            ...insaurance,
                            insurerAndPolicyNumber: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorInsaurance?.insurerAndPolicyNumber
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={insaurance?.insurerAndPolicyNumber}
                      />
                      {errorInsaurance?.insurerAndPolicyNumber && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorInsaurance?.insurerAndPolicyNumber}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-2 form-builder-element mb-3">
                      <label htmlFor="">
                        Period From
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="date"
                        disabled={filledForm?.formStatusByHR}
                        max={formatDate(new Date())}
                        onChange={(e) => {
                          setInsaurance({
                            ...insaurance,
                            period_form: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorInsaurance?.period_form
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={insaurance?.period_form}
                      />
                      {errorInsaurance?.period_form && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorInsaurance?.period_form}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-2 form-builder-element mb-3">
                      <label htmlFor="">
                        Period To
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="date"
                        disabled={filledForm?.formStatusByHR}
                        max={formatDate(new Date())}
                        onChange={(e) => {
                          setInsaurance({
                            ...insaurance,
                            period_to: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorInsaurance?.period_to
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={insaurance?.period_to}
                      />
                      {errorInsaurance?.period_to && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorInsaurance?.period_to}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Claim Amt. Recd. / Receivable:
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="number"
                        min={0}
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setInsaurance({
                            ...insaurance,
                            claim_amount: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorInsaurance?.claim_amount
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={insaurance?.claim_amount}
                      />
                      {errorInsaurance?.claim_amount && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorInsaurance?.claim_amount}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="form-group mb-3 col-md-12 form-builder-element">
                <label htmlFor="">
                  Medical history to be completed by the Proposer/Insured
                  Person. Please answer the following questions in Yes or No (a
                  dash is not sufficient) and give full details if answer is
                  Yes:
                  <br />
                  Are you in good health, and free from physical and mental
                  disease or infirmity of medical complaints?
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="medi_point_12_yes"
                      disabled={filledForm?.formStatusByHR}
                      type="checkbox"
                      name="mediclaim_history_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="yes"
                      checked={formData?.mediclaim_history_yes_no === "yes"}
                    />
                    <label
                      htmlFor="medi_point_12_yes"
                      className="custom-control-label"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="medi_point_12_no"
                      type="checkbox"
                      name="mediclaim_history_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="no"
                      checked={formData?.mediclaim_history_yes_no === "no"}
                    />
                    <label
                      htmlFor="medi_point_12_no"
                      className="custom-control-label"
                    >
                      No
                    </label>
                  </div>
                </div>
                <div className="row">
                  {formData?.mediclaim_history_yes_no &&
                    formData?.mediclaim_history_yes_no === "no" && (
                      <div className="form-group col-md-6 form-builder-element mb-3">
                        <label htmlFor="">
                          if not in good health give full details :
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="form-control form-view"
                          type="text"
                          disabled={filledForm?.formStatusByHR}
                          onChange={(e) => {
                            setMediclaimHistory({
                              ...mediclaimHistory,
                              not_in_good_health: e.target.value,
                            });
                          }}
                          style={{
                            ...(errorMedicalHistory?.not_in_good_health
                              ? { border: "1px solid red" }
                              : {}),
                          }}
                          value={mediclaimHistory?.not_in_good_health}
                        />
                        {errorMedicalHistory?.not_in_good_health && (
                          <p style={{ color: "red", fontSize: "10px" }}>
                            {errorMedicalHistory?.not_in_good_health}
                          </p>
                        )}
                      </div>
                    )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="form-group mb-3 col-md-12 form-builder-element">
                <label htmlFor="">
                  Have you ever suffered from any of the diseases/ illness? if
                  Yes, details:
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="medi_point_13_yes"
                      disabled={filledForm?.formStatusByHR}
                      type="checkbox"
                      name="disease_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="yes"
                      checked={formData?.disease_yes_no === "yes"}
                    />
                    <label
                      htmlFor="medi_point_13_yes"
                      className="custom-control-label"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="medi_point_13_no"
                      type="checkbox"
                      name="disease_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="no"
                      checked={formData?.disease_yes_no === "no"}
                    />
                    <label
                      htmlFor="medi_point_13_no"
                      className="custom-control-label"
                    >
                      No
                    </label>
                  </div>
                </div>
                {formData?.disease_yes_no === "yes" && (
                  <div className="row">
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any nervous, mental or psychiatric disease:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            nervous_mental: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.nervous_mental
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.nervous_mental}
                      />
                      {errorDisease?.nervous_mental && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.nervous_mental}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Slipped disc or other spinal disorder or (Fainting,
                        episode, blackout, fit) paralysis of any kind:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            spinal_disorder: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.spinal_disorder
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.spinal_disorder}
                      />
                      {errorDisease?.spinal_disorder && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.spinal_disorder}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        High blood pressure, heart diseases, including ischemic
                        heart disease; other circulatory disorder etc.:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            blood_pressure: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.blood_pressure
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.blood_pressure}
                      />
                      {errorDisease?.blood_pressure && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.blood_pressure}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">(Rheumatic fever)</label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            rheumatic_fever: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.rheumatic_fever
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.rheumatic_fever}
                      />
                      {errorDisease?.rheumatic_fever && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.rheumatic_fever}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Fistula, Piles, Hernia, Varicose Veins:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            piles_hernia: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.piles_hernia
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.piles_hernia}
                      />
                      {errorDisease?.piles_hernia && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.piles_hernia}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any disease of the bones or joints including traumatic
                        disease of uterus, ovaries or breast or any
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            bones_joints: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.bones_joints
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.bones_joints}
                      />
                      {errorDisease?.bones_joints && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.bones_joints}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any respiratory or allergic disease
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            respiratory_allergic: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.respiratory_allergic
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.respiratory_allergic}
                      />
                      {errorDisease?.respiratory_allergic && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.respiratory_allergic}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any disorder of the stomach, ulcer, bowel or gall
                        bladder, kidney stones etc:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            stomach_bladder_kidney: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.stomach_bladder_kidney
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.stomach_bladder_kidney}
                      />
                      {errorDisease?.stomach_bladder_kidney && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.stomach_bladder_kidney}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any cancer malignant growth boil cyst. or wound etc.
                        which does not heal or improve despite treatment:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            cancer_wound: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.cancer_wound
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.cancer_wound}
                      />
                      {errorDisease?.cancer_wound && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.cancer_wound}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any other complaint requiring specialists consultation
                        or surgical hospital treatment or investigation:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            surgical_hospital_treatment: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.surgical_hospital_treatment
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.surgical_hospital_treatment}
                      />
                      {errorDisease?.surgical_hospital_treatment && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.surgical_hospital_treatment}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any complaint or tendency that may necessitate such
                        consultation or treatment in the future:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            treatment_in_the_future: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.treatment_in_the_future
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.treatment_in_the_future}
                      />
                      {errorDisease?.treatment_in_the_future && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.treatment_in_the_future}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any dimness of vision / cataract: such consultation or
                        treatment in the future:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            dimness_of_vision: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.dimness_of_vision
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.dimness_of_vision}
                      />
                      {errorDisease?.dimness_of_vision && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.dimness_of_vision}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any disease of ears or difficulty or interference with
                        hearing:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            disease_of_ears: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.disease_of_ears
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.disease_of_ears}
                      />
                      {errorDisease?.disease_of_ears && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.disease_of_ears}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">Diabetes or any Urinary disease:</label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            urinary_disease: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.urinary_disease
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.urinary_disease}
                      />
                      {errorDisease?.urinary_disease && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.urinary_disease}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-4 form-builder-element mb-3">
                      <label htmlFor="">
                        Any other illness or disease or accident or operation
                        sustained by you:
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDisease({
                            ...disease,
                            illness_disease_accident: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDisease?.illness_disease_accident
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={disease?.illness_disease_accident}
                      />
                      {errorDisease?.illness_disease_accident && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDisease?.illness_disease_accident}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="form-group mb-3 col-md-12 form-builder-element">
                <label htmlFor="">
                  Have you ever suffered from dental problems? YES/No
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="medi_point_14_yes"
                      disabled={filledForm?.formStatusByHR}
                      type="checkbox"
                      name="dental_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="yes"
                      checked={formData?.dental_yes_no === "yes"}
                    />
                    <label
                      htmlFor="medi_point_14_yes"
                      className="custom-control-label"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="medi_point_14_no"
                      type="checkbox"
                      name="dental_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="no"
                      checked={formData?.dental_yes_no === "no"}
                    />
                    <label
                      htmlFor="medi_point_14_no"
                      className="custom-control-label"
                    >
                      No
                    </label>
                  </div>
                </div>
                {formData?.dental_yes_no === "yes" && (
                  <div className="row">
                    <div className="form-group col-md-6 form-builder-element mb-3">
                      <label htmlFor="">
                        If yes, Specify same
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDentalHistory({
                            ...dentalHistory,
                            specify_name: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDentalHistory?.specify_name
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={dentalHistory?.specify_name}
                      />
                      {errorDentalHistory?.specify_name && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDentalHistory?.specify_name}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-6 form-builder-element mb-3">
                      <label htmlFor="">
                        When were you treated last for same:
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control form-view"
                        type="text"
                        disabled={filledForm?.formStatusByHR}
                        onChange={(e) => {
                          setDentalHistory({
                            ...dentalHistory,
                            last_treatment: e.target.value,
                          });
                        }}
                        style={{
                          ...(errorDentalHistory?.last_treatment
                            ? { border: "1px solid red" }
                            : {}),
                        }}
                        value={dentalHistory?.last_treatment}
                      />
                      {errorDentalHistory?.last_treatment && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {errorDentalHistory?.last_treatment}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="form-group mb-3 col-md-12 form-builder-element">
                <label htmlFor="">
                  Give particulars in table below or any other illness or
                  disease or accident or operation sustained by you in the past.
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="medi_point_15_yes"
                      disabled={filledForm?.formStatusByHR}
                      type="checkbox"
                      name="table_illness_accident_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="yes"
                      checked={
                        formData?.table_illness_accident_yes_no === "yes"
                      }
                    />
                    <label
                      htmlFor="medi_point_15_yes"
                      className="custom-control-label"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="medi_point_15_no"
                      type="checkbox"
                      name="table_illness_accident_yes_no"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="no"
                      checked={formData?.table_illness_accident_yes_no === "no"}
                    />
                    <label
                      htmlFor="medi_point_15_no"
                      className="custom-control-label"
                    >
                      No
                    </label>
                  </div>
                </div>
                {formData?.table_illness_accident_yes_no === "yes" && (
                  <div className="row">
                    {nominees.map((nominee, index) => {
                      if (nominee) {
                        row = row + 1;
                        return (
                          <Card
                            key={index}
                            title={
                              <div className="d-flex justify-content-between">
                                <span>{`Nominee ${row}`}</span>
                                <div>
                                  {[...nominees.filter((nom) => nom !== null)]
                                    .length !== 1 && (
                                    <div className="col-1 ">
                                      <button
                                        className={`btn ${"btn-danger"} ml-4`}
                                        onClick={() => deleteNominee(index)}
                                      >
                                        <span className="pr-2">
                                          <i
                                            className="fa fa-trash"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                        Delete
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            }
                          >
                            <div className="col-12">
                              <div className="row">
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Nature of illness/ disease injury and
                                    treatment received
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="text"
                                    placeholder=""
                                    name="nature_of_all"
                                    disabled={filledForm?.formStatusByHR}
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[`nature_of_all_${index}`]
                                        ?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.nature_of_all}
                                  />
                                  {nomineeError[`nature_of_all_${index}`]
                                    ?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[`nature_of_all_${index}`]
                                          ?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Date of first treatment
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="date"
                                    placeholder=""
                                    max={formatDate(new Date())}
                                    name="date_of_treatment"
                                    disabled={filledForm?.formStatusByHR}
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[
                                        `date_of_treatment_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.date_of_treatment}
                                  />
                                  {nomineeError[`date_of_treatment_${index}`]
                                    ?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[
                                          `date_of_treatment_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-4 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Name of attending medical practitioner,
                                    surgeon with his address and Telephone No.
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="text"
                                    placeholder=""
                                    name="name_address_tel_practitioner_disease"
                                    disabled={filledForm?.formStatusByHR}
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[
                                        `name_address_tel_practitioner_disease_${index}`
                                      ]?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={
                                      nominee?.name_address_tel_practitioner_disease
                                    }
                                  />
                                  {nomineeError[
                                    `name_address_tel_practitioner_disease_${index}`
                                  ]?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[
                                          `name_address_tel_practitioner_disease_${index}`
                                        ]?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                <div className="form-group col-md-3 form-builder-element mb-3">
                                  <label htmlFor="">
                                    Whether fully cured
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <input
                                    className="form-control form-view"
                                    type="text"
                                    disabled={filledForm?.formStatusByHR}
                                    name="fully_cured"
                                    onChange={(e) =>
                                      handleChangeNominee(e, index)
                                    }
                                    style={{
                                      ...(nomineeError[`fully_cured_${index}`]
                                        ?.index === index
                                        ? { border: "1px solid red" }
                                        : {}),
                                    }}
                                    value={nominee?.fully_cured}
                                  />
                                  {nomineeError[`fully_cured_${index}`]
                                    ?.index === index && (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {
                                        nomineeError[`fully_cured_${index}`]
                                          ?.message
                                      }
                                    </p>
                                  )}
                                </div>
                                {[...nominees.filter((nom) => nom !== null)]
                                  .length < 5 &&
                                  row ===
                                    [...nominees.filter((nom) => nom !== null)]
                                      .length && (
                                    <div className="form-group col-md-3 mb-0 form-builder-element  d-flex justify-content-end  align-items-end">
                                      <button
                                        className={`btn ${"btn-primary"} ml-4`}
                                        onClick={addMore}
                                      >
                                        <span className="pr-2">
                                          <i
                                            className="fa fa-plus"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                        Add More
                                      </button>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </Card>
                        );
                      }
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-12 d-flex justify-content-center">
                <button
                  className={`btn ${
                    filledForm?.formStatusByHR ||
                    IS_DISABLE ||
                    validateInput() ||
                    (formData?.insurer_yes_no === "yes" &&
                      validateInsurance()) ||
                    (formData?.dental_yes_no === "yes" && validateDental()) ||
                    (formData?.table_illness_accident_yes_no === "yes" &&
                      validateNominee()) ||
                    (formData?.mediclaim_history_yes_no === "no" &&
                      mediclaimHistory?.not_in_good_health === "")
                      ? "btn-secondary"
                      : "btn-primary"
                  } `}
                  onClick={handleSubmit}
                  disabled={
                    validateInput() ||
                    IS_DISABLE ||
                    filledForm?.formStatusByHR ||
                    (formData?.insurer_yes_no === "yes" &&
                      validateInsurance()) ||
                    (formData?.dental_yes_no === "yes" && validateDental()) ||
                    (formData?.table_illness_accident_yes_no === "yes" &&
                      validateNominee()) ||
                    (formData?.mediclaim_history_yes_no === "no" &&
                      mediclaimHistory?.not_in_good_health === "")
                  }
                >
                  <span className="pr-2">
                    <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  </span>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}

export default Mediclaim;
